import { axios } from '@/utils/request'

const api = {
  goodsOptions: '/badminapi/kanjia/goodsOptions',
  youhuiquanOptions: '/badminapi/kanjia/youhuiquanOptions',
  kanjiaDetail: '/badminapi/kanjia/kanjiaDetail',
  kanjiaList: '/badminapi/kanjia/kanjiaList',
  kanjiaEdit: '/badminapi/kanjia/kanjiaEdit',
  kanjiaAdd: '/badminapi/kanjia/kanjiaAdd',
  kanjiaDelete: '/badminapi/kanjia/kanjiaDelete',
  setKanjiaAllStatus: '/badminapi/kanjia/setKanjiaAllStatus',
  kanjiaOrderList: '/badminapi/kanjia/orderList',
}

export default api

export function getKanjiaList(parameter) {
  return axios({
    url: api.kanjiaList,
    method: 'get',
    params: parameter
  })
}
export function getKanjiaDetail(parameter) {
  return axios({
    url: api.kanjiaDetail,
    method: 'get',
    params: parameter
  })
}
export function getGoodsOptions(parameter) {
  return axios({
    url: api.goodsOptions,
    method: 'get',
    params: parameter
  })
}
export function getYouhuiquanOptions(parameter) {
  return axios({
    url: api.youhuiquanOptions,
    method: 'get',
    params: parameter
  })
}
export function editKanjia(parameter) {
  return axios({
    url: api.kanjiaEdit,
    method: 'post',
    data: parameter
  })
}
export function addKanjia(parameter) {
  console.log('addKanjia');
  console.log(parameter);
  return axios({
    url: api.kanjiaAdd,
    method: 'post',
    data: parameter
  })
}

export function deleteKanjia(parameter) {
  return axios({
    url: api.kanjiaDelete,
    method: 'post',
    data: parameter
  })
}


export function setKanjiaAllStatus(parameter) {
  return axios({
    url: api.setKanjiaAllStatus,
    method: 'post',
    data: parameter
  })
}
export function getKanjiaUserList(parameter) {
  return axios({
    url: api.kanjiaOrderList,
    method: 'post',
    data: parameter
  })
}